import { createSlice } from "@reduxjs/toolkit";

export const hiddenFareRuleSlice = createSlice({
    name: "hiddenFareRule",
    initialState: {
        rules: [],
        loading: false,
        error: null
    },
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setHiddenFareRules: (state, action) => {
            state.loading = false;
            state.rules = action.payload;
        },
        setError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
    },
});

export const { setLoading, setHiddenFareRules, setError } = hiddenFareRuleSlice.actions;
export default hiddenFareRuleSlice.reducer;
